export enum ParserType {
  Default = 'default',
  GP_Brewton = 'gp_brewton_parser',
  FALCON_H0 = 'falcon_h0_parser',
}
